import styled from 'styled-components'
import {StyledLink} from '../../../styledComponents/adminPage/Links'
import {BoldSpan} from '../../../styledComponents/StyledSpan'
import { Table, TableCell, TableProps } from '@mui/material';
import React from 'react'

export const NoMarginInnerTable = (props: TableProps) => <Table size={'small'}>{props.children}</Table>

export const MinimumWidthTableCell = styled(TableCell)`
  width: 1px;
  white-space: nowrap;
`

export const TextAlignMinimumWidthTableCell = styled(MinimumWidthTableCell)`
  text-align: right!important;
`

export const NoPLMinimumWidthTableCell = styled(MinimumWidthTableCell)`
  padding-left: 0!important;
`

export const LeftMarginBoldSpan = styled(BoldSpan)`
  margin-left: 20px;
`

export const LeftMarginLink = styled(StyledLink)`
  margin-left: 20px!important;
`
